<ng-container *ngIf="state">
  <app-processing-indicator
    [error]="error"
    [percentageComplete]="progress"
    [title]="title"
    [status]="status"
    [message]="message"
  ></app-processing-indicator>
</ng-container>
